import { httpGet } from 'utils';

export interface OutstandingFeeAmountReponse {
  totalOutstandingFeesAmount: number;
  partialOutstandingFeesAmount: number;
}

export const outstandingFeeAmounts = () =>
  httpGet<OutstandingFeeAmountReponse>('portal/OutstandingManagementFeeAmount');
